// ============================================================
//  Qbrix Product Page JS
//  Handles: gallery slider, qty, floating CTA, lightbox, reviews
// ============================================================
(function () {
  'use strict';

  // ── Gallery ──────────────────────────────────────────────────

  var prodCurrentSlide = 0;
  var prodTotalSlides = 0;
  var _promoToastTimer = null;

  function prodInitGallery() {
    var slides = document.querySelectorAll('.prod-gallery-slide');
    prodTotalSlides = slides.length;
    if (prodTotalSlides === 0) return;

    // Update counter initially
    prodUpdateGalleryCounter();

    // Touch swipe on main image
    var mainImg = document.getElementById('prod-main-img');
    if (mainImg) {
      var touchStartX = 0;
      var touchEndX = 0;
      mainImg.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });
      mainImg.addEventListener('touchend', function (e) {
        touchEndX = e.changedTouches[0].screenX;
        if (touchStartX - touchEndX > 50) prodGalleryNext();
        if (touchEndX - touchStartX > 50) prodGalleryPrev();
      });
    }

    // Thumb track scroll arrows
    setTimeout(prodUpdateThumbArrows, 100);

    var thumbTrack = document.getElementById('prod-thumb-track');
    if (thumbTrack) {
      thumbTrack.addEventListener('scroll', prodUpdateThumbArrows);
    }
  }

  function prodSetSlide(idx) {
    var slides = document.querySelectorAll('.prod-gallery-slide');
    if (slides.length === 0) return;

    prodCurrentSlide = (idx + slides.length) % slides.length;

    // Show/hide slides
    slides.forEach(function (slide, i) {
      slide.style.opacity = (i === prodCurrentSlide) ? '1' : '0';
    });

    // Update thumb active state
    var thumbs = document.querySelectorAll('.thumb-btn');
    thumbs.forEach(function (btn, i) {
      btn.classList.toggle('active', i === prodCurrentSlide);
    });

    // Scroll active thumb into view
    var track = document.getElementById('prod-thumb-track');
    var activeThumb = thumbs[prodCurrentSlide];
    if (track && activeThumb) {
      activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      setTimeout(prodUpdateThumbArrows, 350);
    }

    prodUpdateGalleryCounter();

    // Gallery engagement tracking
    window._qbxGalleryViews = (window._qbxGalleryViews || 0) + 1;
    if (window._qbxGalleryViews === 5 && typeof qbxTrack === 'function') {
      var btn = document.getElementById('prod-atc-btn');
      qbxTrack('gallery_engaged', { product_id: btn ? btn.dataset.productId : '' });
    }
  }

  function prodUpdateGalleryCounter() {
    var counter = document.getElementById('prod-gallery-counter');
    if (counter && prodTotalSlides > 0) {
      counter.textContent = (prodCurrentSlide + 1) + ' / ' + prodTotalSlides;
    }
  }

  function prodUpdateThumbArrows() {
    var track = document.getElementById('prod-thumb-track');
    if (!track) return;
    var prevBtn = document.getElementById('prod-thumb-prev');
    var nextBtn = document.getElementById('prod-thumb-next');
    var atStart = track.scrollLeft <= 4;
    var atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    if (prevBtn) prevBtn.style.display = atStart ? 'none' : 'flex';
    if (nextBtn) nextBtn.style.display = atEnd ? 'none' : 'flex';
  }

  // Global functions — called from inline onclick attributes
  window.prodGalleryNext = function () { prodSetSlide(prodCurrentSlide + 1); };
  window.prodGalleryPrev = function () { prodSetSlide(prodCurrentSlide - 1); };

  window.prodSwitchSlide = function (idx) { prodSetSlide(idx); };

  window.prodThumbScroll = function (dir) {
    var track = document.getElementById('prod-thumb-track');
    if (!track) return;
    var firstChild = track.querySelector('*');
    var thumbWidth = firstChild ? firstChild.offsetWidth + 8 : 96;
    track.scrollLeft += dir * thumbWidth * 3;
    setTimeout(prodUpdateThumbArrows, 350);
  };

  // ── Quantity selector ─────────────────────────────────────────

  window.prodUpdateQty = function (change) {
    var input = document.getElementById('prod-qty');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    val = Math.min(99, Math.max(1, val + change));
    input.value = val;
  };

  // ── Floating sticky CTA ───────────────────────────────────────

  function prodInitFloatingCta() {
    var anchor = document.getElementById('prod-cta-anchor');
    var stickyCta = document.getElementById('prod-sticky-cta');
    if (!anchor || !stickyCta) return;

    var observer = new IntersectionObserver(function (entries) {
      var isVisible = entries[0].isIntersecting;
      if (isVisible) {
        stickyCta.classList.remove('visible');
      } else {
        stickyCta.classList.add('visible');
      }
    }, { threshold: 0 });

    observer.observe(anchor);
  }

  // ── Bundle add — AJAX add both items to cart ─────────────────

  window.prodHandleBundleAdd = function (btn) {
    var mainId = btn.getAttribute('data-main-id');
    var bonusId = btn.getAttribute('data-bonus-id');

    if (!mainId) {
      // Fallback: just visual feedback
      var orig = btn.innerHTML;
      btn.classList.add('added');
      btn.innerHTML = 'DITAMBAHKAN! ✓';
      setTimeout(function () { btn.classList.remove('added'); btn.innerHTML = orig; }, 2000);
      return;
    }

    btn.disabled = true;
    btn.innerHTML = 'Menambahkan…';

    var items = [{ id: parseInt(mainId, 10), quantity: 1 }];
    if (bonusId) items.push({ id: parseInt(bonusId, 10), quantity: 1 });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function (res) { return res.json(); })
    .then(function () {
      if (typeof qbxTrack === 'function') {
        var atcBtn = document.getElementById('prod-atc-btn');
        qbxTrack('add_to_cart', {
          currency: atcBtn ? atcBtn.dataset.currency : 'IDR',
          value: atcBtn ? parseInt(atcBtn.dataset.price, 10) / 100 : 0,
          items: [{ item_id: mainId, item_name: 'bundle', quantity: items.length }]
        });
      }
      btn.classList.add('added');
      btn.innerHTML = 'DITAMBAHKAN! ✓';
      btn.disabled = false;
      // Update cart count in header if element exists
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var countEls = document.querySelectorAll('[data-cart-count],.cart-count,.header-cart-count');
          countEls.forEach(function (el) { el.textContent = cart.item_count; });
        });
      setTimeout(function () {
        btn.classList.remove('added');
        btn.innerHTML = 'TAMBAH KOLEKSI LENGKAP';
      }, 3000);
    })
    .catch(function () {
      btn.disabled = false;
      btn.innerHTML = 'Coba lagi';
      setTimeout(function () { btn.innerHTML = 'TAMBAH KOLEKSI LENGKAP'; }, 2000);
    });
  };

  // ── ATC Breadcrumb animation ──────────────────────────────────

  function prodInitBreadcrumbs() {
    var nav = document.getElementById('breadcrumbs-nav');
    if (!nav) return;
    var bcObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          nav.classList.add('crumbs-played');
          bcObserver.unobserve(nav);
        }
      });
    }, { threshold: 0.5 });
    bcObserver.observe(nav);
  }

  // ── Cara Rakitnya — V3 timeline entrance ─────────────────────

  function prodInitTimeline() {
    var timelineEl = document.getElementById('prod-cara-rakit');
    if (!timelineEl) return;

    var tlObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          timelineEl.classList.add('v3-in');
          tlObserver.unobserve(timelineEl);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -20px 0px' });

    tlObserver.observe(timelineEl);

    // Fallback: all steps visible after 2s
    setTimeout(function () {
      document.querySelectorAll('.v3-item').forEach(function (el) {
        el.classList.add('v3-item-visible');
      });
      timelineEl.classList.add('v3-in');
    }, 2000);
  }

  // ── Benefits ticker seamless loop ────────────────────────────

  function prodInitTicker() {
    var inner = document.getElementById('prod-bene-ticker-inner');
    var group = document.getElementById('prod-bene-ticker-group');
    if (inner && group && !inner.dataset.cloned) {
      inner.appendChild(group.cloneNode(true));
      inner.dataset.cloned = '1';
    }
  }

  // ── Reviews tabs ─────────────────────────────────────────────

  window.prodSwitchTab = function (tabId, btn) {
    // Deactivate all tabs and content
    document.querySelectorAll('.prod-tab-btn').forEach(function (b) {
      b.classList.remove('active');
    });
    document.querySelectorAll('.prod-tab-content').forEach(function (c) {
      c.classList.remove('active');
    });

    // Activate clicked
    if (btn) btn.classList.add('active');
    var target = document.getElementById(tabId);
    if (target) target.classList.add('active');
  };

  window.prodLoadMore = function (btn) {
    document.querySelectorAll('.prod-review-hidden').forEach(function (el) {
      el.style.display = '';
      el.classList.remove('prod-review-hidden');
    });
    btn.style.display = 'none';
    var wrap = document.getElementById('prod-load-more-2-wrap');
    if (wrap) wrap.style.display = '';
    prodBuildLbItems();
  };

  window.prodLoadMore2 = function (btn) {
    var spinner = document.getElementById('prod-load-more-2-spinner');
    var text = document.getElementById('prod-load-more-2-text');
    if (btn.dataset.loading) return;
    btn.dataset.loading = '1';
    btn.disabled = true;
    if (spinner) spinner.style.display = '';
    if (text) text.style.display = 'none';
    setTimeout(function () {
      if (spinner) spinner.style.display = 'none';
      if (text) text.style.display = '';
      btn.disabled = false;
      delete btn.dataset.loading;
    }, 1000);
  };

  // ── Membantu counter ─────────────────────────────────────────
  function prodInitMembantu() {
    document.getElementById('prod-reviews-list').addEventListener('click', function (e) {
      var btn = e.target.closest('[data-membantu]');
      if (!btn || btn.dataset.voted) return;
      btn.dataset.voted = '1';
      var m = btn.textContent.match(/(\d+)/);
      if (m) btn.textContent = btn.textContent.replace(m[0], String(parseInt(m[0], 10) + 1));
      btn.style.color = '#B1D9C0';
    });
  }

  // ── Review form ───────────────────────────────────────────────

  window.prodUpdateFotoLabel = function (input) {
    var lbl = document.getElementById('prod-foto-label-text');
    if (!lbl) return;
    if (input.files && input.files[0]) {
      lbl.textContent = input.files[0].name;
      lbl.style.color = '#B1D9C0';
    } else {
      lbl.textContent = 'Klik untuk pilih foto hasil rakitan';
      lbl.style.color = '';
    }
  };

  window.prodSubmitReview = function (e) {
    e.preventDefault();
    var rating = document.querySelector('#prod-star-rating input:checked');
    if (!rating) {
      var hint = document.getElementById('prod-rating-hint');
      if (hint) {
        hint.textContent = 'Pilih rating dulu ya!';
        hint.style.color = '#E02F85';
      }
      return;
    }
    var form = document.getElementById('prod-review-form');
    var success = document.getElementById('prod-review-success');
    if (form) form.style.display = 'none';
    if (success) success.classList.remove('hidden');
  };

  // Star rating hint
  function prodInitStarRating() {
    var labels = document.querySelectorAll('#prod-star-rating label');
    var hint = document.getElementById('prod-rating-hint');
    var ratingText = ['', '1 bintang', '2 bintang', '3 bintang', '4 bintang', '5 bintang — Sempurna!'];

    labels.forEach(function (lbl) {
      lbl.addEventListener('mouseenter', function () {
        var val = parseInt(lbl.htmlFor.replace('ps', ''), 10);
        if (hint) hint.textContent = ratingText[val] || '';
      });
    });

    document.querySelectorAll('#prod-star-rating input').forEach(function (inp) {
      inp.addEventListener('change', function () {
        var val = parseInt(inp.value, 10);
        if (hint) hint.textContent = ratingText[val] || '';
      });
    });
  }

  // ── Lightbox ──────────────────────────────────────────────────

  var prodLbIndex = 0;
  var prodLbItems = []; // built at init from .prod-review-photo-btn and .prod-review-photo

  function prodBuildLbItems() {
    // Collect all lightbox-able review photos in DOM order
    prodLbItems = [];
    document.querySelectorAll('.prod-review-photo-btn, .prod-review-photo').forEach(function (el) {
      var img = el.querySelector('img');
      if (img) {
        prodLbItems.push({ type: 'img', src: img.dataset.src || img.src, alt: img.alt });
      } else {
        // Gradient fallback
        var bg = el.style.background || el.style.backgroundColor || '#1A1A2E';
        var lbl = el.getAttribute('data-label') || el.querySelector('span') && el.querySelector('span').textContent || 'Foto Customer';
        prodLbItems.push({ type: 'bg', bg: bg, label: lbl });
      }
    });
  }

  window.prodOpenLightbox = function (idx) {
    prodBuildLbItems();
    prodLbIndex = Math.min(idx, prodLbItems.length - 1);
    prodRenderLbPhoto();
    var lb = document.getElementById('prod-lightbox');
    if (lb) {
      lb.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
  };

  window.prodCloseLightbox = function () {
    var lb = document.getElementById('prod-lightbox');
    if (lb) {
      lb.classList.remove('open');
      document.body.style.overflow = '';
    }
  };

  window.prodCloseLightboxOnBg = function (e) {
    if (e.target === document.getElementById('prod-lightbox')) {
      prodCloseLightbox();
    }
  };

  window.prodLbNav = function (dir) {
    if (prodLbItems.length === 0) return;
    prodLbIndex = (prodLbIndex + dir + prodLbItems.length) % prodLbItems.length;
    prodRenderLbPhoto();
  };

  function prodRenderLbPhoto() {
    var content = document.getElementById('prod-lb-content');
    var counter = document.getElementById('prod-lb-counter');
    if (!content) return;

    var ph = prodLbItems[prodLbIndex];
    if (!ph) return;

    if (ph.type === 'img') {
      content.innerHTML = '<img src="' + ph.src + '" alt="' + (ph.alt || 'Foto Customer') + '" style="max-width:100%;max-height:80vh;object-fit:contain;border-radius:8px;display:block;" loading="eager">';
      content.style.background = '';
    } else {
      content.innerHTML = '<span style="font-size:13px;color:rgba(255,255,255,0.4);">' + ph.label + '</span>';
      content.style.background = ph.bg;
    }

    if (counter) counter.textContent = (prodLbIndex + 1) + ' / ' + prodLbItems.length;
  }

  function prodInitReviewLazyLoad() {
    var lazyImgs = document.querySelectorAll('.rev-lazy-img[data-src]');
    if (!lazyImgs.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var img = entry.target;
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
          io.unobserve(img);
        }
      });
    }, { rootMargin: '200px' });
    lazyImgs.forEach(function (img) { io.observe(img); });
  }

  function prodInitLightbox() {
    prodBuildLbItems();
    document.addEventListener('keydown', function (e) {
      var lb = document.getElementById('prod-lightbox');
      if (!lb || !lb.classList.contains('open')) return;
      if (e.key === 'Escape') prodCloseLightbox();
      if (e.key === 'ArrowLeft') prodLbNav(-1);
      if (e.key === 'ArrowRight') prodLbNav(1);
    });
  }

  // ── BELI SEKARANG — add to cart then redirect to /cart ───────

  function prodInitBuyNow() {
    var btn = document.getElementById('prod-buy-btn');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var variantInput = document.getElementById('prod-variant-id');
      var qtyInput = document.getElementById('prod-qty');
      var variantId = variantInput ? parseInt(variantInput.value, 10) : null;
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      if (!variantId) return;

      btn.disabled = true;
      btn.style.opacity = '0.7';

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          var atcBtn = document.getElementById('prod-atc-btn');
          if (typeof qbxTrack === 'function' && atcBtn) {
            qbxTrack('add_to_cart', {
              currency: atcBtn.dataset.currency,
              value: parseInt(atcBtn.dataset.price, 10) / 100,
              items: [{ item_id: atcBtn.dataset.productId, item_name: atcBtn.dataset.productTitle,
                         price: parseInt(atcBtn.dataset.price, 10) / 100, quantity: qty }]
            });
          }
          window.location.href = '/cart';
        })
        .catch(function () {
          btn.disabled = false;
          btn.style.opacity = '';
        });
    });
  }

  // ── hdr-observe for section headers ──────────────────────────
  // Note: qbrix-homepage.js handles .hdr-observe globally on homepage.
  // On product page, we handle it here since qbrix-homepage.js is not loaded.

  function prodInitHdrObserve() {
    var hdrObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('hdr-in-view');
          hdrObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    document.querySelectorAll('.hdr-observe').forEach(function (el) {
      hdrObserver.observe(el);
    });
  }

  // ── Promo Banner Init ─────────────────────────────────────────────────────────────
  function initPromoBanner() {
    var wheelPromo = '';
    var promoCode  = '';
    var wheelPhone = '';
    try {
      wheelPromo = localStorage.getItem('qbrix_wheel_promo') || '';
      promoCode  = localStorage.getItem('qbrix_promo_code') || '';
      wheelPhone = localStorage.getItem('qbrix_wheel_phone') || '';
    } catch(e) {}

    var hasWheelEl = document.getElementById('prod-promo-has-wheel');
    var noWheelEl  = document.getElementById('prod-promo-no-wheel');
    var pendingEl  = document.getElementById('prod-promo-pending');
    if (!hasWheelEl || !noWheelEl) return;

    if (wheelPromo) {
      // Состояние A
      hasWheelEl.style.display = 'flex';
      var codeLabel = document.getElementById('prod-promo-code-label');
      if (codeLabel) codeLabel.textContent = wheelPromo;

      // Цена со скидкой 10% — берём из data-атрибута блюр-элемента
      var priceEl = document.getElementById('prod-promo-price');
      var blurEl = document.querySelector('.prod-promo-blur-price');
      if (priceEl && blurEl) priceEl.textContent = blurEl.dataset.price;

      // Если уже klaim — сразу показать Aktif
      if (promoCode) {
        var btn = document.getElementById('prod-promo-btn');
        var textEl = document.getElementById('prod-promo-text');
        if (btn) {
          btn.textContent = '\u2713 Aktif';
          btn.style.background = '#22c55e';
          btn.style.color = '#fff';
          btn.disabled = true;
        }
        if (textEl) {
          textEl.textContent = '\u2014 diskon 10% aktif';
          textEl.style.color = '#b2d9c0';
        }
      }
    } else if (wheelPhone && !wheelPromo) {
      // Состояние C — номер есть, промо ещё не получен
      if (pendingEl) pendingEl.style.display = 'flex';
    } else {
      // Состояние B
      noWheelEl.style.display = 'flex';
    }
  }

  // ── Promo Claim ───────────────────────────────────────────────────────────────────────────────
  window.prodClaimPromo = function(btn) {
    var wheelPromo = '';
    try { wheelPromo = localStorage.getItem('qbrix_wheel_promo') || ''; } catch(e) {}
    var code = wheelPromo || (window.QbrixWheelConfig && window.QbrixWheelConfig.promoCode) || '';
    if (!code) return;

    try { localStorage.setItem('qbrix_promo_code', code); } catch(e) {}

    // Кнопка → Aktif
    btn.textContent = '\u2713 Aktif';
    btn.style.background = '#22c55e';
    btn.style.color = '#fff';
    btn.disabled = true;

    var textEl = document.getElementById('prod-promo-text');
    if (textEl) {
      textEl.textContent = '\u2014 diskon 10% aktif';
      textEl.style.color = '#b2d9c0';
    }

    // Inline тост
    var toastEl = document.getElementById('prod-promo-toast');
    if (toastEl) {
      toastEl.innerHTML =
        '<div style="background:rgba(34,197,94,0.1);border:1px solid rgba(34,197,94,0.3);border-radius:10px;padding:10px 14px;">' +
          '<p style="font-family:var(--font-body,sans-serif);font-size:13px;color:#22c55e;font-weight:700;margin:0 0 4px;">\ud83c\udf89 Best price aktif!</p>' +
          '<p style="font-family:var(--font-body,sans-serif);font-size:12px;color:#9ca3af;margin:0;">' +
            'Diskon 10% diterapkan otomatis di keranjang. Tambahkan produk &amp; checkout!' +
          '</p>' +
        '</div>';
      toastEl.style.display = 'block';
      toastEl.style.opacity = '1';
      toastEl.style.transition = 'opacity 0.3s';
      // Скрыть через 4 секунды — очищаем предыдущий таймер если есть
      if (_promoToastTimer) { clearTimeout(_promoToastTimer); _promoToastTimer = null; }
      _promoToastTimer = setTimeout(function() {
        toastEl.style.opacity = '0';
        setTimeout(function() { toastEl.style.display = 'none'; _promoToastTimer = null; }, 300);
      }, 4000);
    }
  };

  // ── Init all ──────────────────────────────────────────────────

  document.addEventListener('DOMContentLoaded', function () {
    if (!document.getElementById('prod-reviews-list') && !document.querySelector('.prod-gallery-main')) return;

    // ── Description expand ─────────────────────────────────────
    // Only registered on regular product pages (not hobby pages which use qbrix-hobby.js)
    window.prodDescToggle = function(e) {
      e.preventDefault();
      var desc = document.getElementById('prod-desc-full');
      var fade = document.getElementById('prod-desc-fade');
      if (!desc) return;
      desc.classList.add('prod-desc-expanded');
      if (fade) fade.style.display = 'none';
    };

    prodInitGallery();
    prodInitFloatingCta();
    prodInitBreadcrumbs();
    prodInitTimeline();
    prodInitTicker();
    prodInitStarRating();
    prodInitLightbox();
    prodInitHdrObserve();
    prodInitReviewLazyLoad();
    prodInitMembantu();
    prodInitBuyNow();
    initPromoBanner();
  });

})();
